import { render, staticRenderFns } from "./FormSignView.vue?vue&type=template&id=cdf55f56"
import script from "./FormSignView.vue?vue&type=script&lang=js"
export * from "./FormSignView.vue?vue&type=script&lang=js"
import style0 from "./FormSignView.vue?vue&type=style&index=0&id=cdf55f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports